import { useSpinner } from "@components/SpinnerContext";
import accomodationService from "@services/accomodation.service";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Page404 from '@pages/NotFoundPage';
import CardSuggestion from "@components/CardSuggestion";
import PageHeader from "@components/PageHeader";
import InputComponent from "@components/InputComponent";
import { t } from "i18next";
import { AccomodationTranslationLocation } from "@models/accomodation-translation-location";

const SuggestionPage = () => {
  const { showSpinner, hideSpinner, loading } = useSpinner();
  const [isPageNotFound, setIsPageNotFound] = useState(false);
  const location = useLocation();
  const [cardSuggestion, setCardSuggestion] = useState<AccomodationTranslationLocation[] | undefined>(undefined)
  const [filteredCardSuggestion, setFilteredCardSuggestion] = useState<AccomodationTranslationLocation[] | undefined>(undefined)

  useEffect(() => {
    async function getSuggestionData(id: number, qrCodeId: string) {
      try {
        showSpinner()
        const response = await accomodationService.getSuggestions(qrCodeId)
        setCardSuggestion(response)
        setFilteredCardSuggestion(response)
      } catch (error) {
        setIsPageNotFound(true)
        console.log(error);
      } finally {
        hideSpinner()
      }
    }

    const parts = location.pathname.split("/").filter(Boolean);
    const qrCodeId = parts[0];
    const id = parts[parts.length - 2];

    getSuggestionData(parseInt(id), qrCodeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="mx-3">
      <div className="sticky-top sticky-header border-bottom border-light">
        <PageHeader pageTitle={t("text.otherproposals")} flagSearch={false} flag={false} />
        <div className="col-12">
          <InputComponent list={cardSuggestion} setFilteredList={setFilteredCardSuggestion} isAccomodation={true}/>
        </div>
      </div>
      {isPageNotFound ? (
        <Page404 />
      ) : (
        loading ? null : (
          <div className="container mt-4">
            <div className="row g-3">
              {filteredCardSuggestion?.map((suggestion, i) => (
                <div className="col-12 col-md-6 col-lg-4 col-xl-3 d-flex align-items-stretch" key={i}>
                  <div className="card-suggestion d-block h-100 w-100">
                    <CardSuggestion cardSuggestionTranslation={suggestion?.accomodationTranslationDto} accomodationLocation = {suggestion?.location}/>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )
      )}
    </div>

  );
};
export default SuggestionPage;